import { Navigate, Outlet } from "react-router-dom";
import { useAlumniAuth } from "../contexts/AlumniAuthContext";

const AlumniProtectedRoute = () => {
  const { alumni, loading } = useAlumniAuth();

  if (loading) return <div>Loading...</div>;
  if (!alumni) return <Navigate to="/alumni/login" replace />;

  return <Outlet />;
};

export default AlumniProtectedRoute;